import * as React from 'react';
import { PropsAndElementAttrs, RequireAria } from '../../utils/ReactHelpers';
import { CheckBoxWithLabelProps } from './CheckBoxWithLabelWidget';
import { CheckBoxWithLabelWidget } from './SelectorShims';

export interface CheckBoxWithLabelGroupProps extends RequireAria<'aria-labelledby'> {
  /** @deprecated instead use `children` */
  checkBoxWithLabelPropsList?: CheckBoxWithLabelProps[];

  children?: Array<React.ReactElement<CheckBoxWithLabelWidget['props']>>;

  role?: never;
}

/**
 * This Widget should be used *only* if the list of checkboxes forms a logical group with a visible label.
 * See https://www.w3.org/TR/wai-aria-practices-1.1/#checkbox
 */
export class CheckBoxWithLabelGroupWidget extends React.PureComponent<PropsAndElementAttrs<CheckBoxWithLabelGroupProps>> {
  public render(): JSX.Element {
    // eslint-disable-next-line deprecation/deprecation
    const { checkBoxWithLabelPropsList, children, ...htmlAttrs } = this.props;
    return <div {...htmlAttrs} role='group'>
      {children || checkBoxWithLabelPropsList?.map((props, index) => <CheckBoxWithLabelWidget {...props} key={index} />)}
    </div>;
  }
}
